//#region src/housekeeping/roomOccupancy.ts
var e = /* @__PURE__ */ function(e) {
	return e.OutOfOrder = "out_of_order", e.Turnover = "turnover", e.Arriving = "arriving", e.Departing = "departing", e.StayOver = "stay_over", e.Vacant = "vacant", e;
}({}), t = Object.values(e), n = (t) => {
	if (t.status === "out_of_order") return e.OutOfOrder;
	let { arriving: n, departing: r, booking_id: i } = t.day;
	return n && r ? e.Turnover : n ? e.Arriving : r ? e.Departing : i ? e.StayOver : e.Vacant;
};
//#endregion
export { t as ROOM_OCCUPANCIES, e as RoomOccupancy, n as roomOccupancy };
